import React from 'react'
import PropTypes from 'prop-types'

# components
import Modal  from 'react-bootstrap/lib/Modal'
import Toggle from '/components/toggle'

# icons
import FaPencil from 'react-icons/lib/fa/pencil'

# utils
import uniqueId from 'underscore-es/uniqueId'

import flash        from '/lib/flash'
import withAbility  from '/lib/with-ability'

import { withUpdatePersonalDetails } from './queries'

export default \
withAbility \
withUpdatePersonalDetails \
class EditUserDetails extends React.Component
  @propTypes:
    user:       PropTypes.object
    className:  PropTypes.string

  @defaultProps:
    className: 'btn btn-default btn-xs'

  constructor: ->
    super arguments...
    @ids = uniqueId 'edit-user-details-'
    @state = {open: false, saving: false, @fields()...}

  fields: ->
    {first_name, last_name, is_business, email, unconfirmed_email} = @props.user or {}
    first_name:   first_name or ''
    last_name:    last_name or ''
    is_business:  !!is_business
    email:        unconfirmed_email or email or ''

  #
  # actions
  #

  # email edits are gated the same way the mutation gates them: agents can't
  # touch a host's email, everyone else falls back to plain update
  canEditEmail: =>
    if @props.user?.is_host
      @props.can 'update_host_email', 'User'
    else
      @props.can 'update', 'User'

  # re-seed from the user's current values on every open, so closing the modal
  # without confirming discards whatever was typed
  open: (evt)=>
    evt?.preventDefault?()
    @setState {open: true, saving: false, @fields()...}

  close: =>
    @setState open: false

  valid: =>
    return false unless @state.first_name?.trim()
    return false unless @state.is_business or @state.last_name?.trim()
    return false if @canEditEmail() and not @state.email?.trim()
    true

  save: (evt)=>
    evt?.preventDefault?()
    return unless @valid()

    details =
      first_name:   @state.first_name.trim()
      last_name:    if @state.is_business then null else @state.last_name.trim()
      is_business:  @state.is_business
    details.email = @state.email.trim() if @canEditEmail()

    @setState saving: true
    {user, errors} = await @props.updatePersonalDetails @props.user.id, details
    @setState saving: false

    if errors?.length
      flash.error errors
    else
      flash.success "User updated successfully"
      @close()

  #
  # renders
  #
  render: ->
    return null unless @props.user?.id
    return null unless @props.can 'update', 'User'

    <span className="EditUserDetails">
      <button
        type="button"
        className={@props.className}
        title="Edit personal details"
        onClick={@open}
      >
        <FaPencil/> Edit
      </button>
      {@modal()}
    </span>

  modal: ->
    <Modal show={@state.open} onHide={@close}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Personal Details</Modal.Title>
      </Modal.Header>

      <form onSubmit={@save}>
        <Modal.Body>

          <div className="form-group">
            <Toggle
              id={"#{@ids}-is-business"}
              value={@state.is_business}
              onChange={(is_business)=> @setState {is_business}}
            />
            <label htmlFor={"#{@ids}-is-business"}>
              Organization account
            </label>
          </div>

          <div className="form-group">
            <label htmlFor={"#{@ids}-first-name"}>
              {if @state.is_business then 'Organization name' else 'First Name'}
            </label>
            <input
              id={"#{@ids}-first-name"}
              type="text"
              className="form-control"
              value={@state.first_name}
              onChange={(evt)=> @setState first_name: evt.target.value}
            />
          </div>

          {unless @state.is_business
            <div className="form-group">
              <label htmlFor={"#{@ids}-last-name"}>Last Name</label>
              <input
                id={"#{@ids}-last-name"}
                type="text"
                className="form-control"
                value={@state.last_name}
                onChange={(evt)=> @setState last_name: evt.target.value}
              />
            </div>
          }

          {if @canEditEmail()
            <div className="form-group">
              <label htmlFor={"#{@ids}-email"}>Email</label>
              <input
                id={"#{@ids}-email"}
                type="email"
                className="form-control"
                value={@state.email}
                onChange={(evt)=> @setState email: evt.target.value}
              />
            </div>
          }

        </Modal.Body>

        <Modal.Footer>
          <button type="button" className="btn btn-default" onClick={@close}>
            Cancel
          </button>
          <button type="submit" className="btn btn-primary" disabled={@state.saving or not @valid()}>
            {if @state.saving then 'Saving...' else 'Confirm'}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
